Object.defineProperty(exports, "__esModule", { value: true })

exports.default = __webpack_require__.stylable.create(
  "root",
  "MemberCard787470930",
  {"root":"MemberCard787470930--root","action":"MemberCard787470930--action","done":"MemberCard787470930--done","doneLabel":"MemberCard787470930--doneLabel","check":"MemberCard787470930--check","iconWidth":"24px","columnGap":"0.2em","paddingAction":"calc(24px + 0.2em)"},
  "",
  2,
  "MemberCard787470930"
);

